import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { getHomeUrl } from '../../services/environment';

import './Header.scss';

export default function Header({ currentUser }) {
  const location = useLocation();

  return (
    <div className="app-header">
      <a href={getHomeUrl()} className="tool-name">
        <img
          src="https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/icons/dsn-logo192.png"
          className="logo"
          alt="Adobe Demo System Next"
        />
        <span>Adobe Demo System Next</span>
      </a>

      <span className="main-nav">
        <a href="/" className="main-nav-link">
          Home
        </a>

        <Link
          to="/quick-setup"
          className={classNames(
            'main-nav-link',
            location.pathname === '/quick-setup' && 'active'
          )}>
          Setup
        </Link>

        <Link
          to="/environments"
          className={classNames(
            'main-nav-link',
            location.pathname === '/environments' && 'active'
          )}>
          Environments
        </Link>

        <a href="/tools" className="main-nav-link">
          Tools
        </a>

        <a href="/install" className="main-nav-link">
          Mobile
        </a>

        <a href="/status" className="main-nav-link">
          Status
        </a>

        <a href="/help" className="main-nav-link">
          Help
        </a>
      </span>

      <span className="current-user">{currentUser.id}</span>
    </div>
  );
}
